import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import './VerifyMFA.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const VerifyMFA = () => {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [backupCode, setBackupCode] = useState('');
  const [useBackup, setUseBackup] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/mfa/verify`, {
        token: useBackup ? null : token,
        backupCode: useBackup ? backupCode : null
      }, {
        withCredentials: true
      });

      if (response.data.requiresPasswordChange) {
        // Redirect to force password change
        navigate('/force-password-change');
      } else if (response.data.user) {
        await checkAuth();
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid token or backup code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-mfa-container">
      <div className="verify-mfa-card">
        <div className="verify-mfa-header">
          <h1>🔐 Two-Factor Authentication</h1>
          <p>Enter the 6-digit code from your authenticator app</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <div className="mfa-tabs">
          <button
            className={`tab-btn ${!useBackup ? 'active' : ''}`}
            onClick={() => setUseBackup(false)}
          >
            Authenticator Code
          </button>
          <button
            className={`tab-btn ${useBackup ? 'active' : ''}`}
            onClick={() => setUseBackup(true)}
          >
            Backup Code
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mfa-form">
          {!useBackup ? (
            <div className="form-group">
              <label className="form-label">6-Digit Code</label>
              <input
                type="text"
                className="form-input mfa-input"
                value={token}
                onChange={(e) => setToken(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                maxLength={6}
                placeholder="000000"
                autoFocus
              />
            </div>
          ) : (
            <div className="form-group">
              <label className="form-label">Backup Code</label>
              <input
                type="text"
                className="form-input mfa-input"
                value={backupCode}
                onChange={(e) => setBackupCode(e.target.value.replace(/\D/g, '').slice(0, 8))}
                required
                maxLength={8}
                placeholder="00000000"
                autoFocus
              />
              <p className="form-hint">Enter one of your backup codes</p>
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-large"
            disabled={loading}
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyMFA;
